import { z } from 'zod';

const DecimalStringSchema = z.union([z.string(), z.number()]).transform((value) =>
  typeof value === 'number' ? String(value) : value,
);

/**
 * PositionResponse — wire shape from GET /api/v1/portfolio/positions.
 * Jackson SNAKE_CASE. BigDecimal fields are strings on the wire.
 */
export const PositionResponseSchema = z.object({
  id: z.string().min(1),
  book_id: z.string().min(1),
  instrument_id: z.string().min(1).nullable(),
  product_type: z.string(),
  asset_class: z.string(),
  currency: z.string(),
  quantity: DecimalStringSchema,
  notional_aggregate: DecimalStringSchema,
  market_value: DecimalStringSchema,
  clean_value: DecimalStringSchema,
  accrued_interest: DecimalStringSchema,
  book_value: DecimalStringSchema,
  unrealized_pnl: DecimalStringSchema,
  realized_pnl: DecimalStringSchema,
  day_pnl: DecimalStringSchema,
  deal_count: z.number().int(),
  last_updated_at: z.string(),
});

export type PositionResponse = z.infer<typeof PositionResponseSchema>;

/** Payload type — agent can prefill filters via ui_action. */
export const PortfolioPositionsPayloadSchema = z.object({
  bookId: z.string().optional(),
  currency: z.string().optional(),
  assetClass: z.string().optional(),
  asOfDate: z.string().optional(),
});

export type PortfolioPositionsPayload = z.infer<typeof PortfolioPositionsPayloadSchema>;

/** Payload type for PortfolioSummary — same filter dimensions as the blotter. */
export const PortfolioSummaryPayloadSchema = z.object({
  bookId: z.string().optional(),
  currency: z.string().optional(),
  assetClass: z.string().optional(),
  asOfDate: z.string().optional(),
});

export type PortfolioSummaryPayload = z.infer<typeof PortfolioSummaryPayloadSchema>;
